import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { SocialSidebar } from '../../components/feature/SocialSidebar';
import { BPHero } from './components/BPHero';
import { BPProducts } from './components/BPProducts';
import { BPRituals } from './components/BPRituals';
import { BPIngredients } from './components/BPIngredients';

const testimonials = [
  { name: 'Samira V.', text: 'Ik gebruik de spray elke ochtend als ritueel. Na gebruik voel ik me direct lichter en beschermd. Niet meer zonder!', product: 'Spray', rating: 5 },
  { name: 'Yasmine B.', text: 'Ik los een bal op in mijn bad elke week en zet er eentje in een glas water met cologne in de hoeken van mijn huis. De sfeer is zoveel rustiger geworden!', product: 'Balls', rating: 5 },
  { name: 'Aicha L.', text: 'Het reinigingsbad met het poeder was een complete game-changer. Ik doe het nu wekelijks en het verschil is merkbaar.', product: 'Powder', rating: 5 },
  { name: 'Zara N.', text: 'Dit is een must-have. De zeep ruikt heerlijk en ik voel de beschermende werking direct. Echt authentiek product.', product: 'Soap', rating: 5 },
];

const BlueProtectPage = () => {
  useSEO({
    title: 'Blue Protect Serie | ZpiritualZ - Bescherming Tegen het Boze Oog',
    description: 'Ontdek de Blue Protect Serie van ZpiritualZ. Gebaseerd op eeuwenoude Surinaamse tradities met puur indigofera-extract. Bescherming tegen het boze oog (Ogri Ai, Nazar) met zeep, spray, poeder en ballen.',
    canonical: 'https://www.zpiritualz.com/blue-protect',
    ogImage: 'https://public.readdy.ai/ai/img_res/086649113451296920ca6e1306a92eb3.jpg',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Blue Protect Serie',
        description: 'Ontdek de Blue Protect Serie van ZpiritualZ. Gebaseerd op eeuwenoude Surinaamse tradities met puur indigofera-extract. Bescherming tegen het boze oog (Ogri Ai, Nazar) met zeep, spray, poeder en ballen.',
        url: 'https://www.zpiritualz.com/blue-protect',
        provider: {
          '@type': 'Organization',
          name: 'ZpiritualZ',
          url: 'https://www.zpiritualz.com',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Blue Protect Serie Producten',
        url: 'https://www.zpiritualz.com/blue-protect',
        numberOfItems: 4,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Blue Protect Soap', url: 'https://www.zpiritualz.com/shop/bp-1', offers: { '@type': 'Offer', price: '14.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 2, name: 'Blue Protect Balls (5 Balls)', url: 'https://www.zpiritualz.com/shop/bp-2', offers: { '@type': 'Offer', price: '14.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 3, name: 'Blue Protect Powder', url: 'https://www.zpiritualz.com/shop/bp-3', offers: { '@type': 'Offer', price: '12.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
          { '@type': 'ListItem', position: 4, name: 'Blue Protect Spray (120ml)', url: 'https://www.zpiritualz.com/shop/bp-4', offers: { '@type': 'Offer', price: '14.95', priceCurrency: 'EUR', availability: 'https://schema.org/InStock' } },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Wat is de Blue Protect Serie?',
            acceptedAnswer: { '@type': 'Answer', text: 'De Blue Protect Serie is een collectie spirituele beschermingsproducten van ZpiritualZ, gebaseerd op eeuwenoude Surinaamse tradities met puur indigofera-extract (blauw poeder) voor bescherming tegen het boze oog — Ogri Ai, Nazar of Azul.' },
          },
          {
            '@type': 'Question',
            name: 'Wat is het verschil tussen Blue Protect en Evil Energy Destroy?',
            acceptedAnswer: { '@type': 'Answer', text: 'Blue Protect is gebaseerd op indigofera-extract en richt zich op bescherming tegen het boze oog. Evil Energy Destroy is gebaseerd op hing (asafoetida) en is bedoeld voor het actief vernietigen van kwade energieën en negatieve invloeden.' },
          },
          {
            '@type': 'Question',
            name: 'Hoe gebruik ik de Blue Protect Spray?',
            acceptedAnswer: { '@type': 'Answer', text: 'Spuit 3-5 keer rondom je lichaam van hoofd tot voet met gesloten ogen. Visualiseer een beschermend blauw licht. Gebruik ook in ruimtes door in hoeken en bij deuren te sprayen. Schud goed voor gebruik.' },
          },
        ],
      },
    ],
  });

  return (
  <div className="min-h-screen bg-[#050010]">
    <SocialSidebar />

    <BPHero />
    <BPProducts />
    <BPRituals />
    <BPIngredients />

    {/* Cultural context */}
    <section className="w-full py-20 bg-[#060012]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="relative rounded-2xl overflow-hidden h-72 lg:h-96">
            <img
              src="https://readdy.ai/api/search-image?query=ancient%20Surinamese%20cultural%20spiritual%20ritual%20scene%20blue%20indigo%20powder%20ceremony%20traditional%20heritage%20mystical%20dark%20atmospheric%20background%20cultural%20diversity%20protection%20ritual%20symbolic%20deep%20violet%20blue%20tones%20cinematic%20warm%20glow%20ancient%20tradition&width=700&height=500&seq=bpcultural1&orientation=landscape"
              alt="Culturele oorsprong Blue Protect"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060012]/80 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4">
              <span className="px-3 py-1.5 bg-violet-700/60 border border-violet-500/30 rounded-full text-violet-300 text-xs font-semibold">
                Surinaamse Erfenis 🇸🇷
              </span>
            </div>
          </div>
          <div>
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Oorsprong & Cultuur ✦</p>
            <h2 className="text-3xl font-black text-white mb-5">
              Eeuwenoud gebruik,<br />
              <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
                moderne vorm
              </span>
            </h2>
            <p className="text-white/55 text-sm leading-relaxed mb-4">
              Blauw poeder wordt al duizenden jaren gebruikt in Surinaamse en andere wereldculturen voor bescherming
              tegen het boze oog — <em>Ogri Ai</em> in het Surinaams, <em>Nazar</em> bij Hindoestanen, <em>Azul</em> in de Spaanse traditie.
            </p>
            <p className="text-white/55 text-sm leading-relaxed mb-6">
              Blue Protect bewaart dit erfgoed in zijn puurste vorm. Het indigofera-extract wordt gewonnen precies
              zoals onze voorouders dat deden — handmatig, zonder chemische verwerkingsstappen, met respect voor de traditie.
            </p>
            <div className="grid grid-cols-3 gap-3">
              {[
                { flag: '🇸🇷', label: 'Surinaams', name: 'Ogri Ai' },
                { flag: '🪬', label: 'Hindoestaans', name: 'Nazar' },
                { flag: '🌍', label: 'Afrikaans', name: 'Mauvais Oeil' },
              ].map(c => (
                <div key={c.name} className="p-3 bg-[#0a0820]/60 border border-violet-500/15 rounded-xl text-center">
                  <span className="text-xl block mb-1">{c.flag}</span>
                  <p className="text-white/30 text-xs">{c.label}</p>
                  <p className="text-violet-300 text-xs font-bold mt-0.5">{c.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Testimonials */}
    <section className="w-full py-20 bg-[#050010]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Ervaringen ✦</p>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">
            Wat Klanten{' '}
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              Zeggen
            </span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map(t => (
            <div key={t.name} className="bg-[#0a0820]/60 border border-violet-500/15 rounded-2xl p-6">
              <div className="flex gap-0.5 mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-violet-400 text-xs" />
                  </div>
                ))}
              </div>
              <p className="text-white/60 text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-violet-700/30 border border-violet-500/20">
                    <i className="ri-user-line text-violet-400 text-xs" />
                  </div>
                  <span className="text-white font-semibold text-xs">{t.name}</span>
                </div>
                <span className="text-violet-400/60 text-xs px-2 py-0.5 bg-violet-900/20 border border-violet-500/15 rounded-full">{t.product}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Cross-sell Evil Energy */}
    <section className="w-full py-14 bg-gradient-to-b from-[#050010] to-[#0d0000]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="relative rounded-2xl overflow-hidden border border-red-500/15 p-8 lg:p-10">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=dark%20dramatic%20dual%20energy%20split%20blue%20violet%20and%20deep%20red%20spiritual%20power%20contrast%20two%20forces%20protection%20light%20and%20dark%20cosmic%20energy%20cinematic%20atmospheric%20wide%20banner&width=1400&height=300&seq=bpcrosssell1&orientation=landscape"
              alt="Evil Energy Protect"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#050010]/95 via-[#050010]/80 to-[#0d0000]/90" />
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-2">Voor zwaardere gevallen</p>
              <h3 className="text-white font-black text-2xl mb-2">
                Ook de{' '}
                <span className="text-transparent bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text">
                  Evil Energy Destroy Serie
                </span>{' '}
                ontdekken?
              </h3>
              <p className="text-white/45 text-sm max-w-lg leading-relaxed">
                Bij zware spirituele aanvallen, hardnekkige kwade energieën of herhaalblootstelling — de Evil Energy Destroy Serie is onze krachtigste formule.
              </p>
            </div>
            <Link
              to="/evil-energy-destroy"
              className="shrink-0 inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-red-700 to-orange-700 text-white font-bold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-flash-line text-sm" />
              </div>
              Bekijk Evil Energy Protect
            </Link>
          </div>
        </div>
      </div>
    </section>

    {/* Final CTA */}
    <section className="w-full py-24 bg-[#050010] relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=deep%20mystical%20violet%20blue%20spiritual%20energy%20light%20rays%20ethereal%20protection%20aura%20indigo%20cosmos%20dark%20background%20sacred%20light%20beams%20ancient%20ceremony%20cinematic%20glow%20wide%20banner%20atmospheric&width=1920&height=600&seq=bpcta2&orientation=landscape"
          alt="Blue Protect CTA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#050010]/88" />
      </div>
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 text-center">
        <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-4">✦ Begin Vandaag ✦</p>
        <h2 className="text-4xl lg:text-5xl font-black text-white mb-5">
          Jouw Bescherming<br />
          <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
            Begint Hier
          </span>
        </h2>
        <p className="text-white/45 text-sm max-w-xl mx-auto leading-relaxed mb-10">
          Stap in een eeuwenoude beschermingstraditie. Puur, authentiek en krachtig — precies zoals onze voorouders het bedoelden.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="#producten"
            className="inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-black text-base rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-cart-line" />
            </div>
            Kies je Product
          </a>
          <Link
            to="/consultations"
            className="inline-flex items-center gap-2 px-10 py-4 bg-white/5 border border-white/20 text-white font-semibold text-base rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-customer-service-line" />
            </div>
            Vraag Advies
          </Link>
        </div>
        <div className="flex flex-wrap justify-center gap-6 text-white/30 text-xs">
          <span className="flex items-center gap-1.5">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-shield-check-line text-violet-500" />
            </div>
            100% Puur Indigofera-extract
          </span>
          <span className="flex items-center gap-1.5">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-truck-line text-violet-500" />
            </div>
            Snel Verzonden
          </span>
          <span className="flex items-center gap-1.5">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-lock-line text-violet-500" />
            </div>
            Veilig Bestellen
          </span>
        </div>
      </div>
    </section>

    {/* Sticky Section Nav */}
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 hidden lg:flex items-center gap-1 px-3 py-2 bg-[#0a0820]/80 backdrop-blur-xl border border-violet-500/20 rounded-full">
      {[
        { href: '#producten', label: 'Producten', icon: 'ri-box-3-line' },
        { href: '#rituelen', label: 'Rituelen', icon: 'ri-magic-line' },
        { href: '#ingredienten', label: 'Ingrediënten', icon: 'ri-leaf-line' },
      ].map(item => (
        <a
          key={item.href}
          href={item.href}
          className="flex items-center gap-1.5 px-4 py-2 rounded-full text-white/45 hover:text-violet-300 hover:bg-violet-900/20 transition-all text-xs font-medium cursor-pointer whitespace-nowrap"
        >
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className={`${item.icon} text-xs`} />
          </div>
          {item.label}
        </a>
      ))}
    </div>
  </div>
  );
};

export default BlueProtectPage;
